import React, { Fragment, useContext, useRef } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import axios from "../../context/axios";
import STcontext from "../../context/STcontext";
import { Checkbox } from "primereact/checkbox";
import "./style/moreDetails.css";
import ImagePreview from "../../ImagePreview/ImagePreview";
import ConfirmDeleteTask from "./ConfirmDeleteTask";
export default function DetailsModel({ taskId }) {
   const { NewTask, supportTechiqueTechnicianTask, modeles, searchnInputTEchnicianPerDate, handleSearchTechnicianTaskPerDateClicked, allGps, setAllGps, allSim, setAllSim, handleCheckboxChange, selectedImages, setSelectedImages, deleteImageFn, showSuccessMessage, showErrorMessage } =
      useContext(STcontext);
   const [newDataTask, setNewDataTask] = useState([]);
   const [show, setShow] = useState(false);
   const [is_updated, setIs_updated] = useState(false);
   const [is_loading, setIs_loading] = useState(false);
   const [newImages, setNewImages] = useState([]);
   const [showImages, setShowImages] = useState([]);
   const resetImages = () => {
      showImages.forEach((url) => URL.revokeObjectURL(url));
      setShowImages([]);
      setNewImages([]);
   };
   const handleClose = () => {
      setNewDataTask("");
      setSelectedImages([]);
      resetImages();
      setShow(false)
   };
   const values = [true];
   const [TaskToUpdateFromST, setTaskToUpdateFromST] = useState({
      garantie: false,
      images: [],
   });
   const [fullscreen, setFullscreen] = useState(true);

   const fetchTaskDetails = async (id) => {
      setIs_loading(true);
      try {
         const response = await axios.get(`/api/supportTechnique/getTaskDetails/${id}`);
         const taskData = response.data.task;

         // Transformer les données pour correspondre à la structure attendue
         setTaskToUpdateFromST({
            id: taskData.id,
            user_id: taskData.user_id,
            uti_utilsateur_id: taskData.uti_utilsateur_id,
            vehicule_id: taskData.vehicule_id,
            date_previsionnelle_debut: taskData.date_previsionnelle_debut,
            date_previsionnelle_fin: taskData.date_previsionnelle_fin,
            article_id: taskData.article_id,
            date_fin_realisation: taskData.date_fin_realisation,
            observation: taskData.observation,
            date_affectation: taskData.date_affectation,
            etat_tache: taskData.etat_tache,
            billed: taskData.billed,
            validation: taskData.validation,
            matricule: taskData.matricule,
            IMEI: taskData.IMEI,
            proprietaire: taskData.proprietaire,
            gps_principale: taskData.gps_principale,
            garantie: taskData.garantie,
            SIM: taskData.SIM,
            SIM_proprietaire: taskData.SIM_proprietaire,
            client_name: taskData.client_name,
            user_name: taskData.user_name,
            catache: taskData.catache,
            cityName: taskData.cityName,
            nameModeleGPS: taskData.nameModeleGPS,
            nameModeleSIM: taskData.nameModeleSIM,
            images: taskData.images || [],
            vehicules: taskData.vehicules || {},

         });
      } catch (error) {
         console.error("Erreur lors de la récupération des détails:", error);
         // Gérer l'erreur (afficher notification, etc.)
      } finally {
         setIs_loading(false);
      }
   };

   function handleShow(breakpoint) {
      setFullscreen(breakpoint);
      setShow(true);
      // setTaskToUpdateFromST(taskToUpdate);
      fetchTaskDetails(taskId);
   }

   const handelUpdateTaskFromST = (e) => {
      const { name, value } = e.target;
      setTaskToUpdateFromST({ ...TaskToUpdateFromST, [name]: value });
      setNewDataTask({ ...newDataTask, [name]: value });
   };

   // Lit un fichier et renvoie son contenu en base64 (data URL).
   const readFileAsBase64 = (file) =>
      new Promise((resolve, reject) => {
         const reader = new FileReader();
         reader.onload = () => resolve(reader.result);
         reader.onerror = reject;
         reader.readAsDataURL(file);
      });

   // Redimensionne une image avant l'envoi (les photos de téléphone sont
   // volumineuses). Renvoie null si le navigateur ne sait pas la décoder.
   const downscaleImage = (file, maxDim = 1600, quality = 0.8) =>
      new Promise((resolve) => {
         const objectUrl = URL.createObjectURL(file);
         const img = new Image();
         img.onload = () => {
            URL.revokeObjectURL(objectUrl);
            let { width, height } = img;
            if (width > maxDim || height > maxDim) {
               const ratio = Math.min(maxDim / width, maxDim / height);
               width = Math.max(1, Math.round(width * ratio));
               height = Math.max(1, Math.round(height * ratio));
            }
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            const dataUrl = canvas.toDataURL("image/jpeg", quality);
            resolve({ data: dataUrl.split(",")[1], extension: "jpg" });
         };
         img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            resolve(null);
         };
         img.src = objectUrl;
      });

   const handleFileEvent = async (e) => {
      const files = Array.from(e.target.files || []);
      if (files.length === 0) {
         return;
      }

      // Aperçu local
      showImages.forEach((url) => URL.revokeObjectURL(url));
      setShowImages(files.map((file) => URL.createObjectURL(file)));

      const entries = [];
      const base = Date.now();
      for (let index = 0; index < files.length; index++) {
         const file = files[index];
         const suggestedName = `t${taskId}_${base}_${index}`;
         let converted = await downscaleImage(file);
         if (!converted) {
            // Fichier non décodable par le navigateur (ex: heic selon le
            // navigateur) : on envoie le contenu brut.
            try {
               const raw = await readFileAsBase64(file);
               converted = {
                  data: raw.split(",")[1],
                  extension: (file.type.split("/")[1] || "jpg").toLowerCase(),
               };
            } catch (err) {
               converted = null;
            }
         }
         if (converted && converted.data) {
            entries.push({ ...converted, url_imgtache: suggestedName });
         }
      }
      setNewImages(entries);
   };

   const handleCheckBoxGrantie = (e) => {
      let garantieCheckBox = "";
      if (TaskToUpdateFromST.garantie == false) {
         garantieCheckBox = true;
      } else {
         garantieCheckBox = false;
      }
      setTaskToUpdateFromST({
         ...TaskToUpdateFromST,
         garantie: garantieCheckBox,
      });
      setNewDataTask({ ...newDataTask, garantie: garantieCheckBox });
   };

   const removeInstalledDevice = () => {
      setAllGps(allGps.filter(device => device.serial_number !== newDataTask.IMEI));
      setAllSim(allSim.filter(sim => sim.serial_number !== newDataTask.SIM));
   }

   const updateTaskSubmit = async (e, id) => {
      e.preventDefault();
      try {
         setIs_updated(true);
         const payload = {
            ...(newDataTask && typeof newDataTask === "object" ? newDataTask : {}),
         };
         // Ajout d'images sans toucher aux images existantes.
         if (newImages.length > 0) {
            payload.imagesTask = newImages;
            payload.imagesTaskMode = "append";
         }
         const response = await axios.put(`api/supportTechnique/updateTask/${id}`, payload);
         showSuccessMessage("La tâche a été modifiée");
         if (searchnInputTEchnicianPerDate.startDate != "" && searchnInputTEchnicianPerDate.endDate != "") {
            handleSearchTechnicianTaskPerDateClicked(1);
         }
         else {
            supportTechiqueTechnicianTask();
         }
         setIs_updated(false);
         removeInstalledDevice();
         handleClose();
         setNewDataTask("");
      } catch (err) {
         setIs_updated(false);
         showErrorMessage("impossible de modifier cette tâche");
         console.error(err);
      }
   };

   const confirmDeleteSelectedImages = (e) => {
      return (
         <>
            <ConfirmDeleteTask
               children={<Button variant="outline-danger">Supprimer ({selectedImages?.length}) images</Button>}
               message={`Etes vous sûre de vouloir supprimer cette (${selectedImages?.length}) images ?`}
               id={selectedImages?.length > 1 ? selectedImages : selectedImages[0]}
               deleteFunction={(e) => deleteImage()}
            />
         </>
      );
   };


   const deleteImage = async () => {
      try {
         await deleteImageFn();
         setTaskToUpdateFromST(prevState => ({
            ...prevState,
            images: prevState.images.filter(image => !selectedImages.includes(image.id)),
         }));
      }
      catch (err) {
         console.log("Erreur lors de la suppression des images");
      }
   }


   const [retation, setRetation] = useState(0);
   const getImage = useRef();

   const retateImage = () => {
      setRetation(retation + 90);
   };

   let gpsPosition = "";
   switch (TaskToUpdateFromST.gps_principale) {
      case 0:
         gpsPosition = "Première";
         break;
      case 1:
         gpsPosition = "Deuxième";
         break;
      default:
         gpsPosition = "GPS Position";
   }

   const getModelRelay = () => {
      const relais = TaskToUpdateFromST?.vehicules?.articles?.find((article) => article.modele_id == 21 || article.modele_id == 22);
      switch (relais?.modele_id) {
         case 21:
            return "Spécial";
         case 22:
            return "Normal";
         default:
            return "Sans relais";
      }
   };
   const getSimOwner = () => {
      switch (TaskToUpdateFromST.SIM_proprietaire) {
         case 0:
            return "D3 hi-tech";
         case 1:
            return "client";
         default:
            return "proprietaire SIM";
      }
   }
   return (
      <div>
         <Button
            style={{ background: "none", color: "black", border: "none" }}
            onClick={() => handleShow(values)}
         >
            <VisibilityIcon />
         </Button>
         <Modal show={show} fullscreen={fullscreen} onHide={handleClose}>
            <Modal.Header closeButton>
               <Modal.Title>Détails tâche</Modal.Title>
            </Modal.Header>
            <Modal.Body
               style={{ gap: "20px", marginBottom: "10px", overflowY: "scroll" }}
            >
               {is_loading ? (
                  <div className="text-center p-5">
                     <div className="spinner-border" role="status">
                        <span className="visually-hidden">Chargement...</span>
                     </div>
                     <p>Chargement des détails...</p>
                  </div>
               ) : (
                  <Form
                     noValidate
                     method="POST"
                     onSubmit={(e) => updateTaskSubmit(e, TaskToUpdateFromST.id)}
                  >
                     <Row className="mb-3">
                        {/* NameClient */}
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Nom client: </Form.Label>
                           <Form.Control
                              required
                              list="listClient"
                              type="text"
                              name="client_name"
                              autoComplete="off"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.client_name}
                           />
                           <datalist id="listClient">
                              {NewTask.Clients.map((client) => (
                                 <option key={client.id}>{client.nomComplet}</option>
                              ))}
                           </datalist>
                        </Form.Group>

                        {/* matricule */}
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Matricule: </Form.Label>
                           <Form.Control
                              type="text"
                              name="matricule"
                              autoComplete="off"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.matricule}
                           />
                        </Form.Group>

                        {/* type tache */}
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Type du tâche : </Form.Label>
                           <Form.Control
                              list="typeTasks"
                              type="text"
                              name="catache"
                              autoComplete="off"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.catache}
                           />
                           <datalist id="typeTasks">
                              {NewTask.TypesTasks.map((typeTask) => (
                                 <option key={typeTask.id}>{typeTask.catache}</option>
                              ))}
                           </datalist>
                        </Form.Group>

                        {/* IMEI */}
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>IMEI: </Form.Label>
                           <Form.Control
                              required
                              list="imeiList"
                              type="text"
                              name="IMEI"
                              autoComplete="off"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.IMEI}
                           />
                           <datalist id="imeiList">
                              {allGps ? allGps.map((imei) => (
                                 <option key={imei.id}>{imei.serial_number}</option>
                              )) : ""}
                           </datalist>
                        </Form.Group>
                     </Row>

                     <Row className="mb-3">
                        {/* model GPS */}
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Modele Gps: </Form.Label>
                           <Form.Control
                              required
                              list="modeleGps"
                              autoComplete="off"
                              type="text"
                              name="nameModeleGPS"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.nameModeleGPS}
                           />
                           <datalist id="modeleGps">
                              {modeles.filter((modelName) => modelName.type_id != 4 && modelName.type_id != 5 && modelName.type_id != 8).map((modelName) => (
                                 <option key={modelName.id}>{modelName.nameModele}</option>
                              ))}
                           </datalist>
                        </Form.Group>

                        {/* propreitaire GPS */}
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Prop GPS: </Form.Label>
                           <Form.Select
                              list="proprietaireList"
                              required
                              type="text"
                              name="proprietaire"
                              onChange={handelUpdateTaskFromST}
                           >
                              <option value="none" selected disabled hidden>
                                 {TaskToUpdateFromST.proprietaire === 0
                                    ? "D3 hi-tech"
                                    : TaskToUpdateFromST.proprietaire === 1
                                       ? "client"
                                       : "Proprietaire GPS"}
                              </option>
                              <option disabled>proprietaire</option>
                              <option value="DHT">D3-hi-tech</option>
                              <option value="client">Client</option>
                           </Form.Select>
                        </Form.Group>

                        {/* GPS Position */}
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>GPS Position: </Form.Label>
                           <Form.Select
                              type="text"
                              placeholder=""
                              name="GPSPosition"
                              onChange={handelUpdateTaskFromST}
                           >
                              <option value="none" selected disabled hidden>
                                 {gpsPosition}
                              </option>
                              <option disabled>GPS Position</option>
                              <option value="principale">Première</option>
                              <option value="secondaire">Deuxième</option>
                           </Form.Select>
                        </Form.Group>

                        {/* model SIM */}
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Modele SIM: </Form.Label>
                           <Form.Control
                              type="text"
                              placeholder=""
                              list="modeleSim"
                              autoComplete="off"
                              name="nameModeleSIM"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.nameModeleSIM}
                           />
                           <datalist id="modeleSim">
                              {modeles.filter((modelName) => modelName.type_id == 4 || modelName.type_id == 5).map((modelName) => (
                                 <option key={modelName.id} value={modelName.nameModele}>{modelName.nameModele}</option>
                              ))}
                           </datalist>
                        </Form.Group>
                     </Row>

                     <Row className="mb-3">
                        {/* sim number */}
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>SIM : </Form.Label>
                           <Form.Control
                              list="sim_numbers"
                              required
                              autoComplete="off"
                              type="text"
                              name="SIM"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.SIM}
                           />
                           <datalist id="sim_numbers">
                              {allSim ? allSim.map((imei, index) => (
                                 <option key={index} value={imei.serial_number}>{imei.latest_device_relating.length > 0
                                    ? imei.latest_device_relating.map(
                                       (deviceRelating) => deviceRelating.serial_number
                                    )[0]
                                    : ""}</option>
                              )) : ""}
                           </datalist>
                        </Form.Group>

                        {/* propreitaire sim */}
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Prop SIM: </Form.Label>
                           <Form.Select
                              type="text"
                              placeholder=""
                              name="SIM_proprietaire"
                              onChange={handelUpdateTaskFromST}
                           >
                              <option value="none" selected disabled hidden>
                                 {getSimOwner()}
                              </option>
                              <option disabled>Sim Propreitaire</option>
                              <option value="DHT">D3-hi-tech</option>
                              <option value="client">Client</option>
                           </Form.Select>
                        </Form.Group>

                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Type Relais: </Form.Label>
                           <Form.Select
                              required
                              type="text"
                              name="accesoriesModel"
                              onChange={handelUpdateTaskFromST}
                           >
                              <option disabled selected value="none">{getModelRelay()}</option>
                              {modeles.filter((modelName) => modelName.type_id == 8).map((modelName) => (
                                 <option key={modelName.id}>{modelName.nameModele}</option>
                              ))}

                           </Form.Select>
                        </Form.Group>

                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Garantie: </Form.Label>
                           <Checkbox
                              name="garantie"
                              className="ms-3 mb-2 mt-4"
                              onChange={handleCheckBoxGrantie}
                              checked={
                                 TaskToUpdateFromST && TaskToUpdateFromST.garantie == 0
                                    ? true
                                    : false
                              }
                           ></Checkbox>
                        </Form.Group>
                     </Row>

                     <Row className="mb-3">
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Exécutée par: </Form.Label>
                           <Form.Control
                              required
                              list="userList"
                              type="text"
                              name="user_name"
                              autoComplete="off"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.user_name}
                           />
                           <datalist id="userList">
                              {NewTask.Users.filter((user) => user.profil_id === 1).map(
                                 (user) => (
                                    <option key={user.id}>{user.name}</option>
                                 )
                              )}
                           </datalist>
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Réalisée à : </Form.Label>
                           <Form.Select
                              required
                              type="text"
                              name="cityClient"
                              autoComplete="off"
                              onChange={handelUpdateTaskFromST}
                           >
                              <option selected hidden>
                                 {TaskToUpdateFromST.cityName || "select ville"}
                              </option>
                              <option disabled>select Ville</option>
                              {NewTask.Cities.map((city, index) => (
                                 <option key={index} value={city.id}>
                                    {city.cityName}
                                 </option>
                              ))}
                           </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Date de travail : </Form.Label>
                           <Form.Control
                              type="datetime-local"
                              name="date_previsionnelle_debut"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.date_previsionnelle_debut}
                           />
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Date fin realisation : </Form.Label>
                           <Form.Control
                              type="datetime-local"
                              name="date_fin_realisation"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.date_fin_realisation}
                           />
                        </Form.Group>
                     </Row>
                     <Row>
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Observation : </Form.Label>
                           <Form.Control
                              as="textarea"
                              rows={3}
                              type="text"
                              name="observation"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.observation}
                           />
                        </Form.Group>
                     </Row>
                     {TaskToUpdateFromST.billed != 1 && (
                        <Row className="mb-3">
                           <Form.Group as={Col} md="4" controlId="validationCustomImages">
                              <Form.Label>Ajouter des images : </Form.Label>
                              <Form.Control
                                 type="file"
                                 multiple
                                 accept="image/*"
                                 onChange={handleFileEvent}
                              />
                              <Form.Text className="text-muted">
                                 Vous pouvez sélectionner plusieurs photos. Les images
                                 existantes restent conservées (cochez-en pour les supprimer).
                              </Form.Text>
                           </Form.Group>
                           <Col md="8" className="d-flex align-items-start flex-wrap" style={{ gap: "10px" }}>
                              {showImages.map((url, index) => (
                                 <img
                                    key={index}
                                    src={url}
                                    alt="aperçu"
                                    style={{ width: "110px", height: "auto", borderRadius: "4px" }}
                                 />
                              ))}
                           </Col>
                        </Row>
                     )}
                     <Row className="mb-3 imageSlider" md="2">
                        {TaskToUpdateFromST.images.length > 0
                           ? TaskToUpdateFromST.images.map((imagesTask) => (
                              ImagePreview({ image: imagesTask.url_imgtache, id: imagesTask.id, handleCheckboxChange: (e) => handleCheckboxChange(e) })
                           ))
                           : ""}
                     </Row>
                     {selectedImages?.length >= 1 && (
                        <Row className="mb-5 mt-5">
                           <Col className="d-flex align-items-center justify-content-center">
                              {confirmDeleteSelectedImages()}
                           </Col>
                        </Row>
                     )}
                     {TaskToUpdateFromST.billed != 1 && (
                        <Row className="mb-5 mt-5">
                           <Col className="d-flex align-items-center justify-content-center">
                              <Button type="submit" variant="primary" disabled={is_updated}>
                                 Enregistrer les modifications
                              </Button>
                           </Col>
                        </Row>
                     )}


                  </Form>
               )}
            </Modal.Body>
         </Modal>
      </div>
   );
}
